module.exports = __webpack_public_path__ + "static/newLogoWhite740x300-db06264640bf5c54a83c36c189691290.svg";